import React from 'react';
import { OnlyNewUI } from 'src/shared/globals';
import { T } from 'src/shared/helpers';
import ShapeCircle from 'src/shared/svg/shapeCircle';
import ShapeRectangle from 'src/shared/svg/shapeRectangle';
import styled from 'styled-components';

const Container = styled.div<{ $selected?: boolean }>`
    width: 50%;
    font-size: 13px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    border: 1px solid rgba(219, 226, 230, 1);
    border-radius: 8px;
    padding: 20px;
    cursor: pointer;
    border: ${(props) => (props.$selected ? '1.5px solid rgba(143, 164, 174, 1)' : '1px solid rgba(219, 226, 230, 1)')};
    box-shadow: ${(props) => (props.$selected ? '0px 4px 20px 0px rgba(0, 0, 0, 0.15), 0px 0px 3px 0px rgba(0, 0, 0, 0.1)' : 'none')};

    &:hover {
        border: ${(props) => (!props.$selected ? '1px solid rgba(219, 226, 230, 1)' : '1px solid rgba(143, 164, 174, 1)')};
        box-shadow: ${(props) =>
            !props.$selected
                ? '0px 4px 20px 0px rgba(0, 0, 0, 0.15), 0px 0px 3px 0px rgba(0, 0, 0, 0.1)'
                : '0px 4px 20px 0px rgba(0, 0, 0, 0.15), 0px 0px 3px 0px rgba(0, 0, 0, 0.1)'};
    }

    @media (max-width: 1475px) {
        font-size: 12px;
    }
`;

const ShapeTypeItemImg = styled.div`
    object-fit: contain;
    display: flex;
    justify-content: center;

    > svg {
        @media (min-width: 1325px) and (max-width: 1475px) {
            height: 50px;
        }
        @media (max-width: 1324px) {
            height: 50px;
        }
        height: 80px;
        width: auto;
    }
`;

const ShapeTypeItemLabel = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    > p {
        font-size: 12px;
        color: rgb(68, 90, 100);
        margin: 5px 0 0;
    }
`;

const ShapeTypeContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    min-height: 28px;
`;

export type ShapeType = 'rectangle' | 'circle';

const ShapeTypeMap = {
    rectangle: {
        imageComponent: <ShapeRectangle />,
        text: T._('Rectangular Shapes', 'Admin'),
        description: T._(
            "Select this for products with four sides. You'll be able to define whether it's a rectangle or square by setting the dimensions below.",
            'Admin'
        ),
        value: 0,
        isOnlyUI: false
    },
    circle: {
        imageComponent: <ShapeCircle />,
        text: <span>{T._('Circular Shapes', 'Admin')}</span>,
        description: T._(
            "Select this for circular products. You'll be able to define whether it's a circle or an oval by setting the dimensions below, based on what you want to allow.",
            'Admin'
        ),
        value: 1,
        isOnlyUI: true
    }
};

interface IShapeTypeItemProps {
    type: ShapeType;
    selected?: boolean;
    onClick?: () => void;
}

const ShapeTypeItem = ({ type, selected, onClick }: IShapeTypeItemProps) => {
    return (
        <Container $selected={selected} onClick={onClick}>
            <ShapeTypeContainer>{ShapeTypeMap[type].isOnlyUI && <OnlyNewUI />}</ShapeTypeContainer>
            <ShapeTypeItemImg>{ShapeTypeMap[type].imageComponent}</ShapeTypeItemImg>
            <ShapeTypeItemLabel>
                {ShapeTypeMap[type].text}
                <p>{ShapeTypeMap[type].description}</p>
            </ShapeTypeItemLabel>
        </Container>
    );
};

export default ShapeTypeItem;
